import { render, staticRenderFns } from "./Numerology.vue?vue&type=template&id=d12c859c&"
import script from "./Numerology.vue?vue&type=script&lang=js&"
export * from "./Numerology.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports